<template>
    <a :href="product.url" class="big-item">
        <ProductImage :product="product" singleClass="product-image-small" bundleClass="mini-bundle-image" />

        <div>
            <span v-if="data.product_state_title" class="flag" :class="data.product_state_flag">
                {{ data.product_state_title }}:
            </span>

            {{ product.title }}
        </div>
    </a>
</template>

<script>
    import ProductImage from '../product/ProductImage'

    export default {
        components: {
            ProductImage
        },
        props: {
            product: {
                type: Object
            }
        },
        computed: {
            data() {
                let data = {
                    product_state_flag: this.product.product_state ? this.product.product_state.flag : null,
                    product_state_title: this.product.product_state ? this.product.product_state.title : null
                }

                if ( [2].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name
                }

                if ( [3, 4].includes( this.product.product_type_id ) ) data = {
                    product_state_flag: 'flag-red',
                    product_state_title: this.product.product_type.name
                }

                return data
            }
        },
    }
</script>
